module.exports = __webpack_public_path__ + "img/5.89d66f4b.png";